import PopoverTrigger from 'client/components/aria/Popover/PopoverTrigger/PopoverTrigger';
import PopoverDialog from 'client/components/aria/Popover/PopoverDialog/PopoverDialog';

const Popover = ({ children, content, ...props }) => {
    return (
        <PopoverTrigger label={children} {...props}>
            <PopoverDialog
                data-testid={props['data-testid'] ? props['data-testid'] + '.content' : null}
            >
                {content}
            </PopoverDialog>
        </PopoverTrigger>
    );
};

export default Popover;
